import React from 'react';
import { useSelector } from 'react-redux';
import { useMobileMenu } from '../context/MobileMenuContext';
import './BurgerMenu.css';

const BurgerMenu = () => {
  const { isMobileMenuOpen, toggleMobileMenu, openMobileMenu } = useMobileMenu();
  const { isAuthenticated } = useSelector((state) => state.auth);

  // Only show burger menu on authenticated pages
  if (!isAuthenticated) {
    return null;
  }

  const handleClick = () => {
    toggleMobileMenu();
  };

  return (
    !isMobileMenuOpen &&
    <div className="burger-menu-container">
      <button
        className={`burger-menu-btn ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={handleClick}
        aria-label="Toggle mobile menu"
        aria-expanded={isMobileMenuOpen}
      >
        <span className="burger-line"></span>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
      </button>
    </div>
  );
};

export default BurgerMenu;
